var r=function(r,a){var c=a.maxChars,t=a.charsNumFromStart,n=a.charsNumFromEnd;return r.length>c?"".concat(r.slice(0,t),"...").concat(r.slice(r.length-n)):r};export{r as truncateString};
